export const FIELDS = {

  ID: 'id',
  SALES_ORDER_ID: 'salesOrderId',
  SODATE: 'soDate',
  COMPANY_ID: 'companyId',
  COMPANY_NAME: 'companyName',
  CONTACT_ID: 'contactId',
  CONTACT_FIRST_NAME: 'contactFirstName',
  CONTACT_LAST_NAME: 'contactLastName',
  SALES_PERSON_USER_ID: 'salesPersonUserId',
  SALES_PERSON_USER_FULL_NAME: 'salesPersonUserFullName',
  STATUS_ID: 'statusId',
  STATUS_NAME: 'statusName',
  STATUS: 'status',
  SALES_ORDER_LINE_ID: 'salesOrderLineId',
  PART_ID: 'partId',
  PART_NUMBER: 'partNumber',
  DESCRIPTION: 'description',
  NSNNUMBER: 'nsnNumber',
  UO_MID: 'uoMId',
  UOM: 'uom',
  PACKAGE_ID: 'packageId',
  PACKAGE: 'package',
  QUANTITY_SOLD: 'quantitySold',
  QUANTITY_BACKODERED: 'quantityBackodered',
  QUANTITY_INBOUND: 'quantityInbound',
  QUANTITY: 'quantity',
  QUANTITY_SCHEDULED: 'quantityScheduled',
  QUANTITY_ALLOCATED: 'quantityAllocated',
  QUANTITY_SHIPPED: 'quantityShipped',
  CUSTOMER_DUE_DATE: 'customerDueDate',
  SCHEDULED_SHIP_DATE: 'scheduledShipDate',
  ACTUAL_SHIP_DATE: 'actualShipDate',
  CUSTOMER_DOCK_DATE: 'customerDockDate',
  SHIPPING_METHOD_ID: 'shippingMethodId',
  SHIPPING_PROVIDER_ID: 'shippingProviderId',
  SHIPPING_PROVIDER_NAME: 'shippingProviderName',
  SHIPPING_METHOD_NAME: 'shippingMethodName',
  SHIPPING_DAYS: 'shippingDays',
  SHIP_VIA: 'shipVia',
  TRACKING_NO: 'trackingNo',
  BRING_IN: 'bringIn',
  CREATED_BY_USER_ID: 'createdByUserId',
  CREATED_BY_USER_FULL_NAME: 'createdByUserFullName',
  MODIFIED_BY_USER_ID: 'modifiedByUserId',
  MODIFIED_BY_USER_FULL_NAME: 'modifiedByUserFullName',
  DATE_CREATED: 'dateCreated',
  DATE_MODIFIED: 'dateModified',
  ACTIVE: 'active',
  DATE_CODE: 'dateCode',
  LOT_CODE: 'lotCode',
  REVISION: 'revision',
  COUNTRY_OF_ORIGIN_ID: 'countryOfOriginId',
  COUNTRY_OF_ORIGIN_NAME: 'countryOfOriginName',
  CONDITION_ID: 'conditionId',
  CONDITION: 'condition',
  TESTING_REQUESTED: 'testingRequested',
  MANUFACTURER_ID: 'manufacturerId',
  MFG_NAME: 'mfgName',
  INVENTORY_CLASS_ID: 'inventoryClassId',
  CLASS_NAME: 'className',
  INVENTORY_CATEGORY_ID: 'inventoryCategoryId',
  CATEGORY_NAME: 'categoryName',
  CUSTOMER_PO: 'customerPo',
};